export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"
export const CLOSE_REGISTER_USER_SUCCESSFUL_MODAL = "CLOSE_REGISTER_USER_SUCCESSFUL_MODAL"
export const GET_HOME_COUNTRY_LIST = "GET_HOME_COUNTRY_LIST"
export const GET_HOME_COUNTRY_LIST_SUCCESS = "GET_HOME_COUNTRY_LIST_SUCCESS"
export const CHANGE_HOME_COUNTRY_LIST = "CHANGE_HOME_COUNTRY_LIST"
export const SET_REGISTER_LOADING = "SET_REGISTER_LOADING"